import {Component, OnInit, ViewChild, Input} from '@angular/core';
import {LeftpanelComponent} from '../leftpanel/leftpanel.component';
import {ConfService} from '../conf.service';
import {AccountInfoService} from '../user/account-info.service';
import {Router} from '@angular/router';


@Component({
    selector: 'app-data-transformation-history',
    templateUrl: './data-transformation-history.component.html',
    styleUrls: ['./data-transformation-history.component.scss']
})
export class DataTransformationHistoryComponent implements OnInit {

    @Input() partner = localStorage.getItem('partner');
    @Input() account = localStorage.getItem('account');
    @Input() partnerKey = localStorage.getItem('partnerKey');
    @Input() signInEmail = localStorage.getItem('signInEmail');
    countPartnerPlans: any = 0;
    maxCount: any = 10;
    itemList = [];
    settings = {
        text: 'Select attribute(s) to search instantly',
        selectAllText: 'Select All',
        unSelectAllText: 'Unselect All',
        enableSearchFilter: true,
        autoPosition: false
    };
    plans: any;
    searchText: string;
    filterData: any[];
    componentLoading = false;
    columns = ['Action', 'Name', 'Transformation Plan Id', 'Scheduled Time', 'Total Records', 'Passed', 'Failed', 'Skipped', 'Status'];

    constructor(public platform: LeftpanelComponent,
                public accountInfoService: AccountInfoService,
                private confPost: ConfService,
                public router: Router) {
    }

    ngOnInit() {
        if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
            this.platform.initialisePlatform();
        }
        this.getDataTransformationHistory();
    }

    getDataTransformationHistory() {
        this.componentLoading = true;
        this.confPost.getTransformationHistory(this.signInEmail, this.partner, this.partnerKey).subscribe(data => {
            const res: any = data;
            if (res) {
                this.plans = res;
                this.componentLoading = false;
            }
        }, err => {
            this.platform.handleErrorGracefully(err, 'Error while retrieving plans.');
            this.componentLoading = false;
            this.plans = [];
        });

    }

    view(item) {
        this.router.navigate(['/data-transform/result', item['transformationPlanId']]);
    }

    checkFilter() {
        if (!this.filterData || this.filterData === [] || this.filterData === null) {
            alert('Please select an attribute to filter.');
            this.searchText = '';
        }
    }

}
